import styled, { css } from "styled-components";
import {
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_PRIMARY,
  WHITE
} from "@streeteasy/design-system/colors";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

import arrowLeftBlack from "../../../../../../../app/assets/images/svg/icons/angle_bold_left_black.svg";
import arrowRightBlack from "../../../../../../../app/assets/images/svg/icons/angle_bold_right_black.svg";
import arrowRightGrey from "../../../../../../../app/assets/images/svg/icons/angle_bold_right_grey.svg";
import settingsGrey from "../../../../../../../app/assets/images/svg/icons/settings_gray.svg";

const xPadding = 20;

export const MenuWrapper = styled.div`
  background: ${WHITE};
  box-sizing: border-box;
  display: ${({ isActive }) => (isActive ? "block" : "none")};
  height: auto;
  min-height: 100%;
  overflow-y: auto;
  padding: 0 ${xPadding}px;
  position: relative;
`;

export const BackButton = styled.button.attrs({
  type: "button"
})`
  background: ${GRAY_LIGHTEST} url("${arrowLeftBlack}")
    no-repeat ${xPadding}px 18px;
  border: 0;
  box-shadow: none;
  color: $whaleGrey;
  cursor: pointer;
  font-size: 14px;
  height: 50px;
  margin: 0 -${xPadding}px;
  padding: 14px 38px;
  text-align: left;
  width: calc(100% + ${xPadding * 2}px);
`;

export const ListTitle = styled.h6`
  font-size: 12px;
  margin: 32px 0 0;
`;

export const ItemText = styled.a.attrs(({ as, isWithArrow }) => ({
  as: as || (isWithArrow ? "button" : "a"),
  type: isWithArrow ? "button" : undefined
}))`
  ${css`
    background: none;
    border: none;
    box-shadow: none;
    color: ${TEXT_PRIMARY};
    display: flex;
    font-weight: 500;
    justify-content: space-between;
    margin: 12px 0;

    &:link,
    &:visited {
      color: ${TEXT_PRIMARY};
    }
  `}

  ${({ isBig }) =>
    isBig
      ? css`
          font-size: 20px;
          line-height: 2.75;
          margin: 0;
          padding: 0 ${xPadding}px;
          width: 100%;
        `
      : ""}

  ${({ isWithArrow }) =>
    isWithArrow
      ? css`
          &:after {
            background: url("${arrowRightBlack}") no-repeat top ${xPadding}px right 0;
            content: "";
            height: 54px;
            width: 30px;
          }
        `
      : ""}

  ${({ isSignIn }) =>
    isSignIn
      ? css`
          border: none;
          font-size: 14px;
          height: 24px;
          line-height: 1.6;
          margin: 15px 0 0;
          padding: 0 ${xPadding}px;

          &:after {
            background: url("${settingsGrey}") no-repeat center;
            content: "";
            height: 24px;
            padding: 0;
            position: absolute;
            right: 20px;
            top: 15px;
            width: 24px;
          }
        `
      : ""}
`;

export const MenuListItem = styled.li`
  display: block;
  padding: 0 ${xPadding}px;
  position: relative;

  &:hover {
    text-decoration: none;
  }

  &:after {
    border-bottom: 1px solid ${GRAY_LIGHT};
    content: "";
    display: block;
    height: 1px;
    margin-left: 0;
    width: 100%;
  }

  ${({ isFullSize }) =>
    isFullSize
      ? css`
          margin-left: -${xPadding}px;
          padding: 0;
          width: calc(100% + ${xPadding * 2}px);
        `
      : ""}

  ${({ isTitle }) =>
    isTitle
      ? css`
          > ${ListTitle} {
            padding: 0 ${xPadding}px 5px;
          }

          :after {
            content: none;
          }
        `
      : ""}

  ${({ isFolder }) =>
    isFolder
      ? css`
          margin-top: 5px;

          &::before {
            border-bottom: none;
            color: ${colorPalette.goatGrey};
            content: "FOLDER: ";
            font-size: 12px;
            font-weight: bold;
            left: ${xPadding}px;
            position: absolute;
            top: 15px;
          }

          &::after {
            border: none;
            content: url("${arrowRightGrey}");
            display: inline-block;
            height: 8px;
            margin: 0;
            position: absolute;
            right: 12px;
            top: 20px;
            transform: rotate(90deg);
            width: 16px;
          }
        `
      : ""}

  ${({ isNew }) =>
    isNew
      ? css`
          &:before {
            background-color: ${colorPalette.accent1};
            border-radius: 50%;
            content: "";
            display: block;
            height: 6px;
            left: ${xPadding}px;
            position: absolute;
            top: 12px;
            transform: translateX(-100%);
            width: 6px;
          }
        `
      : ""}

  ${({ isSignIn }) =>
    isSignIn
      ? css`
          &:after {
            content: none;
          }
        `
      : ""}

  ${({ isSignOut }) =>
    isSignOut
      ? css`
          padding: 15px 0;

          &:after {
            content: none;
          }
        `
      : ""}
`;

export const MenuList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 15px 0;

  ${({ isSubMenu }) =>
    isSubMenu
      ? css`
          border-bottom: 1px solid ${GRAY_LIGHT};
          font-size: 14px;

          &:last-child {
            border-bottom: none;
          }
        `
      : ""}

  ${({ isWithSmallerChildBorder }) =>
    isWithSmallerChildBorder
      ? css`
          > li {
            &:nth-last-child(n + 3)::after {
              width: calc(100% - ${xPadding}px);
              margin-left: ${xPadding}px;
            }

            &:last-child::after {
              border: none;
            }
          }
        `
      : ""}
`;
